import React from 'react';
import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

class LzForm extends React.Component {

    onSubmit(ev) {
        const { onSubmit } = this.props;

        // Call if props exist
        if (onSubmit) {
            // Prevent form submission by default
            ev.preventDefault();

            // Submit using the parent call
            onSubmit(ev);

            return;
        }

        // else go as normal
    }

    render() {
        const {
            flat, size, noAction, heading, children, id, name, method, action, target,
            className, style, noCancel, onCancel, cancelLabel, showReset, resetLabel,
            onReset, noSubmit, submitLabel
        } = this.props;

        return (
            <Paper elevation={flat ? 0 : 2}>
                <Container maxWidth={size}>

                    <form
                        id={id} name={name} method={method} action={action} target={target}
                        className={
                            'lz-form' +
                            (className ? ' ' + className : '')
                        }
                        style={style}
                        onSubmit={(ev) => this.onSubmit(ev)}
                    >
                        {heading &&
                            <Typography variant="h6" display="block"
                                style={{
                                    marginTop: 20,
                                    marginBottom: 20,
                                    textTransform: 'uppercase',
                                    color: 'gray',
                                }}
                            >
                                {heading}
                            </Typography>
                        }

                        {children}

                        {!noAction &&
                            <React.Fragment>
                                <div style={{
                                    marginTop: '1em',
                                    marginBottom: '1em',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'flex-end',
                                }}>
                                    {!noCancel && <Button type="button" onClick={() => onCancel()} style={{ marginLeft: 10 }}>{cancelLabel || 'Cancel'}</Button>}
                                    {(showReset || onReset) && <Button type={onReset ? 'button' : 'reset'} style={{ marginLeft: 10 }} onClick={onReset}>{resetLabel || 'Reset'}</Button>}
                                    {!noSubmit && <Button type="submit" color="primary" variant="contained" style={{ marginLeft: 10 }}>{submitLabel || 'Submit'}</Button>}
                                </div>
                            </React.Fragment>
                        }

                    </form>

                </Container>
            </Paper>
        );
    }

}

export default LzForm;
